module.exports = __webpack_public_path__ + "img/NLG-alt.059b4080.svg";